module.exports = __webpack_public_path__ + "img/close-grey.73ecd07d.svg";